import HalfCircleProgressBar from './component.jsx'
export default HalfCircleProgressBar
